import { gridSize } from '@atlassian/jira-common-styles/src/main.tsx';

export const HELP_PANEL_VERSION = '1';
export const HELP_PANEL_ID = 'helpPanel';
export const HELP_PANEL_WIDTH = gridSize * 46;
